export default __webpack_public_path__ + "static/media/ai1.3d1d3a58.png";